<script lang="ts">
  import YouTubePlayer from './YouTubePlayer.svelte'
  import type { Chapter, Topic } from '../lib/types'

  interface Props {
    videoId: string | null
    startTime: number
    displayTime: number
    currentChapter: Chapter | null
    currentTopic: Topic | null
    style?: string
    onTimeUpdate: (time: number) => void
    onDurationChange: (duration: number) => void
    onTitleChange: (title: string) => void
    onPlay: () => void
  }

  let {
    videoId,
    startTime,
    displayTime,
    currentChapter,
    currentTopic,
    style = '',
    onTimeUpdate,
    onDurationChange,
    onTitleChange,
    onPlay,
  }: Props = $props()

  let player: YouTubePlayer

  function formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600)
    const mins = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)
    if (hours > 0) {
      return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    }
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  export function seekTo(seconds: number, offset: number = 0) {
    player?.seekTo(seconds, offset)
  }

  export function togglePlay() {
    player?.togglePlay()
  }

  export function getCurrentTime(): number {
    return player?.getCurrentTime() ?? 0
  }
</script>

<section class="flex flex-col bg-surface-1 overflow-hidden" {style}>
  <div class="flex items-center gap-2 px-3 h-10 border-b border-border-default shrink-0">
    <span class="text-xs text-accent-primary font-mono">{formatTime(displayTime)}</span>
    <h3 class="m-0 text-sm font-medium text-text-primary whitespace-nowrap overflow-hidden text-ellipsis">
      {#if currentChapter}
        {currentChapter.title}
      {:else}
        Video
      {/if}
      {#if currentChapter && currentTopic}
        <span class="text-text-muted"> / </span>
      {/if}
      {#if currentTopic}
        <span class="text-green-400">{currentTopic.name}</span>
      {/if}
    </h3>
  </div>
  <div class="flex-1 bg-black">
    {#if videoId}
      <YouTubePlayer bind:this={player} {videoId} {startTime} {onTimeUpdate} {onDurationChange} {onTitleChange} {onPlay} />
    {/if}
  </div>
</section>
